// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__2UBRq","name":"ConsentHeader_name__16Yo4","birthday":"ConsentHeader_birthday__1qX4B","skeleton":"ConsentHeader_skeleton__3ipKV"};